import {
    getChatEventInfo,
    getContentSeenEvent,
    getCustomerRespondedEvent, getEndedEvent, getStartedEvent
} from "../../survey/controller/SurveyEventManager";
import { Constants } from "../../../model/Constants";

/**
 * class for handling RichMedia and Survey reporting
 * @class {RichMediaReporting}
 *
 */
export class RichMediaReporting {
    $app: any;

    sdkInstance: any;

    chatEventObject: any;

    constructor($app) {
        this.$app = $app;
        this.sdkInstance = $app.getSDKInstance();
        this.chatEventObject = getChatEventInfo(this.sdkInstance);
    }

    /**
     * Construct and make request to log RichMedia rendered event
     * @param {object} jsonSpec
     * @param {string} nodeID
     * @param {string} name
     * @param {string} questions
     */
    sendStartedEvent(jsonSpec, nodeID, name, questions) {
        const startedEvent = getStartedEvent(jsonSpec, "civ2", "chat",
            this.chatEventObject, Constants.RM);
        const content = this.constructContentSeenEvent(jsonSpec, nodeID, name, questions);
        this.sdkInstance.logEventToDW({ eventList: [startedEvent, content] });
    }

    /**
     * Construct and make request to log RichMedia customer responded and widget transition to new page event
     * @param {object} jsonSpec - survey json speck
     * @param {string} oldNodeID - node ID that is currently being attended
     * @param {string} oldNodeName - node Name that is currently being attended
     * @param {object} oldQuestions - object contain question id as key and question as value
     * @param {array} oldAns - array contains answers
     * @param {string} newNodeID - Id of the node that is being transitioned to
     * @param {string} newNodeName - node Name that is currently transitioned to
     * @param {object} newQuestion - object contain question id as key and question as value of new node
     */
    sendRespondedEvent(jsonSpec, oldNodeID, oldNodeName, oldQuestions, oldAns, newNodeID, newNodeName, newQuestion) {
        const resp = getCustomerRespondedEvent(jsonSpec, oldNodeID, oldNodeName, oldQuestions, oldAns, this.chatEventObject, Constants.RM);
        const content = this.constructContentSeenEvent(jsonSpec, newNodeID, newNodeName, newQuestion);

        this.sdkInstance.logEventToDW({ eventList: [resp, content] });
    }

    /**
     * Construct and make request to log RichMedia customer finished event
     * @param {object} jsonSpec
     * @param {string} nodeID
     * @param {string} oNodeName
     * @param {string} completed
     * @param {string} outcome
     * @param {string} oQuestions
     * @param {string} oAns
     */
    sendEndedEvent(jsonSpec, nodeID, oNodeName, completed, outcome, oQuestions, oAns) {
        const resp = getCustomerRespondedEvent(jsonSpec, nodeID, oNodeName, oQuestions, oAns, this.chatEventObject, Constants.RM);
        const endedEvent = getEndedEvent(jsonSpec, completed, outcome, false, this.chatEventObject, Constants.RM);

        this.sdkInstance.logEventToDW({ eventList: [resp, endedEvent] });
    }

    constructContentSeenEvent(jsonSpec, newNodeID, newNodeName, newQuestion) {
        const ques = [];
        const qIds = [];

        newQuestion.forEach(({ id, lbl }) => {
            qIds.push(id);
            ques.push(lbl);
        });
        return getContentSeenEvent(jsonSpec, newNodeID, newNodeName, ques, qIds, this.chatEventObject, Constants.RM);
    }
}
